export const rootPath = '/CorrMonitor';
export const path = `${rootPath}/:zoom?/:lat?/:lon?/:groupName?/:assetType?/:assetId?`;

export const fallbackRootPath = '/AssetView';
export const fallbackPath = `${rootPath}/:zoom?/:lat?/:lon?/:groupName?/:assetType?/:assetId?`;
